module.exports = __webpack_public_path__ + "img/title_logo.e681ecdc.png";